<div>
    <mat-form-field class="w-full">
        <mat-label>Buscar Coleccionista</mat-label>
        <mat-icon>search</mat-icon>
        <input
            matInput
            placeholder="Buscar Coleccionista..."
            id="coleccionista"
            name="coleccionista"
            [formControl]="searchControl"
                (keydown)="BuscarColeccionista($event)"   
            />
    </mat-form-field>
    <p class="text-sm">Buscar Coleccionista por Código, Nombre o Apellido</p>
    
    @if(listadoColeccionistas$ | async; as coleccionistas){
        @if(coleccionistas.length > 0){
            <div class="max-h-64 overflow-y-auto overflow-x-auto">
                <table mat-table [dataSource]="coleccionistas"  class="w-full">
                    <!-- id Column -->
                    <ng-container matColumnDef="id">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef class="text-sm py-1 border-r">
                            Id
                        </th>
                        <td mat-cell *matCellDef="let coleccionista" class="whitespace-nowrap"> {{coleccionista.coleccionista.codigoColeccionista}} </td>
                    </ng-container>

                    <!-- Nombre Column -->
                    <ng-container matColumnDef="nombre">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef class="text-sm py-1 border-r">
                            Coleccionista
                        </th>
                        <td mat-cell *matCellDef="let coleccionista" class="whitespace-nowrap"> {{coleccionista.coleccionista.nombre}} </td>
                    </ng-container>

                    <!-- acciones Column -->
                    <ng-container matColumnDef="acciones">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef class="text-sm py-1 border-r">
                            
                        </th>
                        <td mat-cell *matCellDef="let coleccionista">
                            <button  mat-raised-button 
                                    class="rounded-sm"  
                                    [color]="'primary'"
                                    (click)="seleccionarColeccionista(coleccionista.coleccionista)">
                                Seleccionar
                            </button>
                        </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="['id', 'nombre', 'acciones']" class="bg-gray-300 h-10"></tr>
                    <tr mat-row *matRowDef="let row; columns: ['id', 'nombre', 'acciones']" class="border-b"></tr>
                </table>
            </div>
        }
        @else if(sinResultados){
            <p class="text-red-500 mt-4 text-center">No se encontraron resultados.</p>
        }

    }

    <div class="mt-4">
        <span class="font-semibold">Coleccionista Seleccionado: </span>
        @if(coleccionistaActual){
            <span>{{coleccionistaActual?.nombre}}, ID {{coleccionistaActual?.codigoColeccionista}}
        </span>
        }
        
    </div>

</div>